import { render } from "./SocialNetwork.vue?vue&type=template&id=4e34388e&scoped=true"
import script from "./SocialNetwork.vue?vue&type=script&lang=js"
export * from "./SocialNetwork.vue?vue&type=script&lang=js"

import "./SocialNetwork.vue?vue&type=style&index=0&id=4e34388e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e34388e"]])

export default __exports__